module.exports = __webpack_public_path__ + "img/58_4.9113aa9a.png";